import { css } from 'emotion'

const titleWrapper = css`
  display: flex;
  margin-bottom: 8px;
`

const name = css`
  width: 500px;
`

const profileNameWrapper = css`
  cursor: pointer;
`

const openCloseButton = css`
  margin-right: 5px;
  padding-top: 8px;
`

const pointGroupLabel = css`
  display: inline-block;
  margin-left: 5px;
`

export default {
  titleWrapper,
  name,
  openCloseButton,
  pointGroupLabel,
  profileNameWrapper,
}
